import Vue from 'vue'
import VueI18n from 'vue-i18n'

import {locale as zh}  from './zh.js'
import {locale as en}  from './en.js'


Vue.use(VueI18n)
let messages = {}
messages = {
    ...messages, zh, en
}

// const lang = localStorage.getItem('language') || 'zh'

const lang = 'zh'

const i18n = new VueI18n({
locale: lang, 
messages, 
})

export default i18n


// WEBPACK FOOTER //
// ./src/lang/vue-i18n.js